import { merge } from 'lodash';

export const canEditReminderSource = (source, ancestors) => (
  !!source?.org_id && ancestors?.some(ancestor => ancestor.org_id === source.org_id && ancestor.can_edit === true)
) || false;

export const reminderConfigurationRows = (response, language) => {
  const rows = [];

  response?.data?.forEach(item => {
    const standard = item?.standard || {};
    const phiSafe = item?.phi_safe;

    rows.push({
      ...standard,
      type: item.type,
      language,
      editedLanguage: standard?.source?.language,
      source: standard?.source,
      canEditSource: canEditReminderSource(standard?.source, response?.ancestors),
      actions: item.actions || [],
      isPhiSafe: false,
      message: standard.message,
    });

    if (phiSafe) rows.push({
      ...phiSafe,
      type: item.type,
      language,
      editedLanguage: phiSafe?.source?.language,
      source: phiSafe?.source,
      canEditSource: canEditReminderSource(phiSafe?.source, response?.ancestors),
      actions: item.actions?.filter(a => a.supportedInPhiSafe) || [],
      isPhiSafe: true,
      message: phiSafe.message,
    });
  });

  return rows.filter(row => row.type);
};

export const reminderSourceActions = (reminder, organizationId, isGlobal, isSuperUser = false) => {
  const source = reminder?.source;
  const sourceOrgId = source?.org_id ?? (source?.type === 'global' ? null : undefined);

  const hasOverride = reminder?.hasOverride ?? (reminder?.own_message != null);

  return {
    sourceOrgId,
    canEditSource: source?.type === 'global' ? isSuperUser : !!source?.org_id && reminder?.canEditSource === true,
    canCreateOverride: (!!organizationId || isGlobal) && !hasOverride,
    canClearOverride: hasOverride && (!!organizationId || (isGlobal && reminder.language !== 'en')),
  };
};

export const reminderConfigurationPatch = (languageId, reminders, previousReminders, previousTimeMessages, clearing) => {
  const messages = reminders.filter(item => item.language === languageId && !item.days) || [];
  const timeMessages = reminders.filter(item => item.language === languageId && item.days) || [];

  const isAnyMessageChanged = messages.some(item => {
    const prevMessage = previousReminders.find(d => d.language === languageId && d.type === item.type && d.isPhiSafe === item.isPhiSafe)?.own_message;
    return prevMessage !== item.own_message;
  });

  const isAnyTimeMessageChanged = timeMessages.some(item => {
    const prevMessage = previousReminders.find(d => d.language === languageId && d.type === item.type && d.days === item.days)?.own_message;
    return prevMessage !== item.own_message;
  });

  if ((!clearing && !isAnyMessageChanged && !isAnyTimeMessageChanged) || (clearing && !isAnyMessageChanged && !isAnyTimeMessageChanged)) {
    return null;
  }

  const timeMilestoneMessages = {};
  const remindersData = [];
  const typesUniq = [...new Set(messages.map(item => item.type))];

  typesUniq.forEach(type => {
    const messagesForType = messages.filter(item => item.type === type);
    const messageObj = {};

    messagesForType.forEach(item => {
      if (item.isPhiSafe) {
        const previousMessage = previousReminders.find(d => d.language === languageId && d.type === item.type && d.isPhiSafe === item.isPhiSafe)?.own_message;
        if (previousMessage !== item.own_message) {
          messageObj.phi_safe = item.own_message;
        }
      } else {
        const previousMessage = previousReminders.find(d => d.language === languageId && d.type === item.type && !d.isPhiSafe)?.own_message;
        if (previousMessage !== item.own_message) {
          messageObj.standard = item.own_message;
        }
      }
    });

    if (messageObj.phi_safe || messageObj.standard || messageObj.phi_safe === null || messageObj.standard === null) {
      remindersData.push({ type, ...messageObj });
    }
  });

  const remindersDTO = { data: remindersData, language: languageId };

  timeMessages.filter(item => item.language === languageId).forEach(item => {
    if (!timeMilestoneMessages[item.days]) {
      timeMilestoneMessages[item.days] = {};
    }
    timeMilestoneMessages[item.days][item.timeMessageFor] = item.own_message;
  });

  if (Object.keys(timeMilestoneMessages).length > 0) {
    remindersDTO.time_milestone_messages = clearing
      ? null
      : merge({}, previousTimeMessages[languageId] || {}, timeMilestoneMessages);
  }

  return remindersDTO;
};
